import { ExperienceCriteriaDTO } from '@/DTO/ExperienceCriteria/ExperienceCriteriaDTO';

export interface ExperienceCriteria {
    id: string;
    criterion: string;
}

export function mapGeneratedStringToExperienceCriteria(value: string): ExperienceCriteria {
    return { id: '', criterion: value };
}

export function mapExperienceCriteriaDTOToExperienceCriteria(dto: ExperienceCriteriaDTO): ExperienceCriteria {
    return { ...dto };
}
